export default __webpack_public_path__ + "static/media/tur-icon.7916ad01.svg";